export const COMPANY = "S R ENGINEERS AND FABRICATORS";
export const BRAND = "MODORS STEEL DOOR FRAMES";
export const TAGLINE = "STRONG FRAMES. SOLID FUTURE.";
export const PHONE = "8076047084";
export const PHONE_LINK = "tel:+918076047084";
export const PHONE_DISPLAY = "+91 80760 47084";
export const WA_LINK =
  "https://wa.me/918076047084?text=" +
  encodeURIComponent(
    "Hello MODORS, I am interested in your galvanized steel door/window frames. Please share product details and quotation."
  );
export const ADDRESS_LINES = [
  "B5 Surya Vihar, Near Sector 4 Police Post,",
  "Gurugram, Haryana – 122001",
];
export const DIRECTIONS_LINK =
  "https://www.google.com/maps/search/?api=1&query=" +
  encodeURIComponent("B5 Surya Vihar, Near Sector 4 Police Post, Gurugram, Haryana 122001");
export const GSTIN = "06AMTPR0049P1ZA";
export const CATALOGUE_PDF = "/modors-catalogue.pdf";

export const BRAND_IMG = {
  logo: "/brand/logo.png",
  mark: "/brand/mark.png",
  framesHero: "/brand/frames-hero.png",
  framesTrio: "/brand/frames-trio.png",
  doorFrames: "/brand/door-frames.png",
  windowFrames: "/brand/window-frames.png",
  posterWide: "/brand/poster-wide.jpg",
  posterWelcome: "/brand/poster-welcome.jpg",
};

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1771530789155-b1f03fbf82b5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwzfHx3YXJlaG91c2UlMjBpbnRlcmlvciUyMGVtcHR5fGVufDB8fHx8MTc4NjkwMzM1M3ww&ixlib=rb-4.1.0&q=85",
  cnc: "https://images.unsplash.com/photo-1740209475472-aa7d280f7452?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwxfHxzdGVlbCUyMG1hbnVmYWN0dXJpbmclMjBDTkN8ZW58MHx8fHwxNzg2OTAzMzQxfDA&ixlib=rb-4.1.0&q=85",
  welding: "https://images.pexels.com/photos/28951817/pexels-photo-28951817.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  commercial: "https://images.unsplash.com/photo-1614595737476-42487331b8a1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBjb21tZXJjaWFsJTIwYnVpbGRpbmclMjBleHRlcmlvcnxlbnwwfHx8fDE3ODY5MDMzNDF8MA&ixlib=rb-4.1.0&q=85",
  doors1: "https://images.unsplash.com/photo-1758998256408-ab2c9fbec19b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwzfHxkb29yJTIwZnJhbWUlMjBjb25zdHJ1Y3Rpb258ZW58MHx8fHwxNzg2OTAzMzQxfDA&ixlib=rb-4.1.0&q=85",
  doors2: "https://images.unsplash.com/photo-1497366754035-f200968a6e72?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBvZmZpY2UlMjBpbnRlcmlvciUyMGRvb3J8ZW58MHx8fHwxNzg2OTAzMzUzfDA&ixlib=rb-4.1.0&q=85",
  steelTexture: "https://images.unsplash.com/photo-1667892702884-faa077e80d7b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwzfHxzdGVlbCUyMHRleHR1cmUlMjBiYWNrZ3JvdW5kfGVufDB8fHx8MTc4NjkwMzM0MXww&ixlib=rb-4.1.0&q=85",
  steelStructure: "https://images.unsplash.com/photo-1504307651254-35680f356dfd?auto=format&fit=crop&w=1200&q=80",
  construction: "https://images.unsplash.com/photo-1541888946425-d81bb19240f5?auto=format&fit=crop&w=1200&q=80",
  facade: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=1200&q=80",
  home: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1200&q=80",
  machinery: "https://images.unsplash.com/photo-1516937941344-00b4e0337589?auto=format&fit=crop&w=1200&q=80",
  warehouse: "https://images.unsplash.com/photo-1553413077-190dd305871c?auto=format&fit=crop&w=1200&q=80",
  architecture: "https://images.unsplash.com/photo-1487958449943-2429e8be8625?auto=format&fit=crop&w=1200&q=80",
  welder: "https://images.unsplash.com/photo-1531834685032-c34bf0d84c77?auto=format&fit=crop&w=1200&q=80",
  interior: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&w=1200&q=80",
  apartment: "https://images.unsplash.com/photo-1460317442991-0ec209397118?auto=format&fit=crop&w=1200&q=80",
  blueprint: "https://images.unsplash.com/photo-1503387762-592deb58ef4e?auto=format&fit=crop&w=1200&q=80",
};

export const TRUST_STATS = [
  { top: "GALVANIZED", value: "275 GSM" },
  { top: "STRONG", value: "1.5 MM STEEL" },
  { top: "PRECISION", value: "CNC MANUFACTURED" },
];

export const WHY_STEEL = [
  { icon: "Shield", title: "High Structural Strength", desc: "Pressed steel sections deliver rigidity far beyond conventional timber frames." },
  { icon: "Timer", title: "Long Service Life", desc: "Galvanized steel frames are built to serve for decades without warping." },
  { icon: "BugOff", title: "Termite Resistant", desc: "Steel is naturally immune to termites and wood-boring pests." },
  { icon: "Umbrella", title: "Corrosion Protection", desc: "275 GSM galvanization shields the steel against rust and moisture." },
  { icon: "Ruler", title: "Dimensional Stability", desc: "No shrinkage, swelling or warping with seasonal weather changes." },
  { icon: "Crosshair", title: "Precision Manufacturing", desc: "CNC forming and punching deliver consistent, accurate profiles." },
  { icon: "Building2", title: "Modern Construction Ready", desc: "Engineered for contemporary residential and commercial projects." },
  { icon: "Wrench", title: "Low Maintenance", desc: "No polishing, no pest treatment — minimal upkeep over the frame's life." },
  { icon: "DoorOpen", title: "Multiple Door Types", desc: "Suits flush doors, panel doors and a wide range of shutter designs." },
  { icon: "Landmark", title: "Residential & Commercial", desc: "One frame system for homes, offices, institutions and industry." },
];

export const WHY_MODORS = [
  { num: "01", title: "PREMIUM GALVANIZED STEEL", desc: "275 GSM galvanized steel for improved corrosion resistance." },
  { num: "02", title: "1.5 MM STEEL", desc: "Strong pressed-steel construction designed for demanding applications." },
  { num: "03", title: "PRECISION MANUFACTURING", desc: "CNC-based forming and punching for consistency and accuracy." },
  { num: "04", title: "QUALITY WORKMANSHIP", desc: "MIG welding, spot welding and skilled finishing on every frame." },
  { num: "05", title: "CONSISTENT PRODUCTION", desc: "Standardized manufacturing for repeat orders and project requirements." },
  { num: "06", title: "BUILT FOR PROFESSIONALS", desc: "Suitable for builders, contractors, architects, fabricators, dealers and developers." },
];

export const PROCESS_STEPS = [
  { num: "01", icon: "Cog", title: "CNC PRESS BRAKING", desc: "CNC press brake forming shapes every profile to exact, repeatable dimensions." },
  { num: "02", icon: "Crosshair", title: "PRECISION PUNCHING", desc: "Hinges, lock and fixing points are punched with consistent accuracy." },
  { num: "03", icon: "Flame", title: "MIG WELDING", desc: "Joints are MIG welded for strong, clean structural connections." },
  { num: "04", icon: "Zap", title: "SPOT WELDING", desc: "Spot welding locks assemblies together with neat, uniform welds." },
  { num: "05", icon: "Paintbrush", title: "PAINT BOOTH / SKILLED FINISHING", desc: "Frames are finished in a dedicated paint booth by skilled hands." },
  { num: "06", icon: "PackageCheck", title: "QUALITY CHECK & PACKING", desc: "Every frame is inspected and packed to arrive site-ready." },
];

export const MACHINES = [
  "CNC Press Brake", "Punching", "MIG Welding", "Spot Welding", "Paint Booth", "Skilled Finishing",
];

export const APPLICATIONS = [
  { title: "Residential Homes", img: "home" },
  { title: "Apartments", img: "apartment" },
  { title: "Offices", img: "doors2" },
  { title: "Commercial Buildings", img: "commercial" },
  { title: "Shops & Showrooms", img: "facade" },
  { title: "Industrial Buildings", img: "warehouse" },
  { title: "Institutional Projects", img: "architecture" },
  { title: "Construction Projects", img: "construction" },
];

export const QUALITY_POINTS = [
  "1.5 MM STEEL",
  "275 GSM GALVANIZED",
  "GPSP STEEL",
  "CNC MANUFACTURING",
  "PRECISION PUNCHING",
  "MIG & SPOT WELDING",
  "SKILLED FINISHING",
];

export const AUDIENCE = [
  "Builders", "Contractors", "Architects", "Fabricators",
  "Door Dealers", "Hardware Dealers", "Developers", "Project Contractors",
];

export const DOOR_VARIANTS = [
  {
    name: "MODORS PRIME",
    section: "5.5\u2033 \u00D7 2.5\u2033",
    specs: [
      { label: "Material", value: "GPSP Steel" },
      { label: "Steel Thickness", value: "1.5 mm" },
      { label: "Galvanization", value: "275 GSM" },
      { label: "Section", value: "5.5\u2033 \u00D7 2.5\u2033 (140\u00D763 mm)" },
      { label: "Rebate Options", value: "Single / Double" },
      { label: "Availability", value: "Single & Double Door" },
    ],
  },
  {
    name: "MODORS ECO",
    section: "5.5\u2033 \u00D7 2\u2033",
    specs: [
      { label: "Material", value: "GPSP Steel" },
      { label: "Steel Thickness", value: "1.5 mm" },
      { label: "Galvanization", value: "275 GSM" },
      { label: "Section", value: "5.5\u2033 \u00D7 2\u2033 (140\u00D750 mm)" },
      { label: "Rebate Options", value: "Single / Double" },
      { label: "Availability", value: "Single & Double Door" },
    ],
  },
];

export const WINDOW_FRAME_SPECS = [
  { label: "Material", value: "GPSP Steel" },
  { label: "Steel Thickness", value: "1.5 mm" },
  { label: "Galvanization", value: "275 GSM" },
  { label: "Fabrication", value: "Precision CNC" },
  { label: "Designs", value: "Multiple Sizes & Designs" },
  { label: "Applications", value: "Residential & Commercial" },
];

export const PRODUCT_OPTIONS = [
  "Door Frame – MODORS PRIME (5.5\u2033 \u00D7 2.5\u2033)",
  "Door Frame – MODORS ECO (5.5\u2033 \u00D7 2\u2033)",
  "Window Frame",
  "Other",
];
